import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnAbilityService } from '@lib/ability';
import { SnCamera, SnWidget } from '@lib/api/entities';
import { SnOperationalViewsAPI } from '@lib/api/services';

import { CameraLiveViewDialogComponent } from '../../components';

@Component({
  selector: 'sn-camera-live-view-widget',
  templateUrl: './camera-live-view-widget.component.html',
  styleUrls: ['./camera-live-view-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraLiveViewWidgetComponent implements OnInit, OnDestroy {
  @Input() public widget: SnWidget;
  @Input() public viewId: string;
  public camera: SnCamera;
  public changeTitle = false;
  public readonly canChange: boolean;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _dialog: MatDialog,
    private readonly _cd: ChangeDetectorRef,
    private readonly _operationalViewsAPI: SnOperationalViewsAPI,
    private readonly _ability: SnAbilityService,
  ) {
    this.canChange = this._ability.can({ subject: 'dashboards/widgetobject', action: 'change' });
  }

  public ngOnInit(): void {
    this._checkForCamera();
    this._cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public openCameraDialog(): void {
    const dialogRef = this._dialog.open(CameraLiveViewDialogComponent);
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe((result) => {
        this._cd.detectChanges();
        if (result) {
          this.camera = result;
          this._cd.detectChanges();
          this._saveWidgetCamera(this.camera);
        }
      });
  }

  public editTitle(): void {
    this.changeTitle = true;
  }

  public setTitle(value: boolean): void {
    this.changeTitle = value;
    this._cd.detectChanges();
  }

  public setUpdateTitle(value: string): void {
    this.widget.name = value;
    this._cd.detectChanges();
  }

  private _checkForCamera(): void {
    if (!this.widget.widgetObjects.length) {
      return;
    }

    if (this.widget.widgetObjects[0].object) {
      this.camera = new SnCamera(this.widget.widgetObjects[0].object);
      this._cd.detectChanges();
    }
  }

  private _saveWidgetCamera(camera: SnCamera): void {
    this._operationalViewsAPI
      .updateViewWidget(this.viewId, this.widget.id, {
        widgetObjects: [
          {
            contentType: 'camera',
            objectId: camera.id,
          },
        ],
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe((widget) => {
        this.widget.widgetObjects = widget.widgetObjects;
        this._cd.detectChanges();
      });
  }
}
